var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconMicOff = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", stroke: props.color, strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(0.449 0.449)" },
                React.createElement("path", { d: "M2.6,2.6l23.8,23.8" }),
                React.createElement("path", { d: "M11.3,11.3v3.3c0,1.8,1.5,3.3,3.2,3.3c0.9,0,1.7-0.3,2.3-1 M17.8,11.7V5.9\n\t\tc0-1.8-1.5-3.3-3.2-3.3c-1.5,0-2.9,1.1-3.2,2.6" }),
                React.createElement("path", { d: "M20,19.9c-2.9,3-7.7,3-10.7,0.1C7.8,18.6,7,16.6,7,14.6v-2.2 M22.1,12.4v2.2\n\t\tc0,0.4,0,0.9-0.1,1.3" }),
                React.createElement("path", { d: "M14.6,22.1v4.3" }),
                React.createElement("path", { d: "M10.2,26.5h8.7" })))));
});
export default IconMicOff;
//# sourceMappingURL=IconMicOff.js.map